<div
  class="datepicker-range-trigger"
  [class.open]="isOpen"
  [class.disabled]="isDisabled"
>
  <span
    class="datepicker-range-trigger__field"
    [class.datepicker-range-trigger__field--placeholder]="!startDate"
    (click)="openForStart()"
  >
    {{ startDate ? formatDate(startDate) : startPlaceholder }}
  </span>
  <span class="datepicker-range-trigger__separator">–</span>
  <span
    class="datepicker-range-trigger__field"
    [class.datepicker-range-trigger__field--placeholder]="!endDate"
    (click)="openForEnd()"
  >
    {{ endDate ? formatDate(endDate) : endPlaceholder }}
  </span>
  <button
    *ngIf="hasValue && !isDisabled"
    type="button"
    class="datepicker-clear"
    (click)="clear(); $event.stopPropagation()"
  >
    <i class="icon--close icon--sm"></i>
  </button>
  <button
    type="button"
    class="datepicker-toggle"
    [disabled]="isDisabled"
    (click)="toggleDropdown(); $event.stopPropagation()"
  >
    <i class="icon--calendar icon--md"></i>
  </button>
</div>

<div class="datepicker-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
  <app-calendar-panel
    [viewYear]="viewYear"
    [viewMonth]="viewMonth"
    [isRangeMode]="true"
    [rangeStart]="startDate"
    [rangeEnd]="endDate"
    [rangeHover]="hoveredDate"
    [isSelectingEnd]="isSelectingEnd"
    [min]="min"
    [max]="max"
    (dateSelect)="onDateSelect($event)"
    (dateHover)="onDateHover($event)"
    (viewMonthChange)="onViewMonthChange($event)"
    (viewYearChange)="onViewYearChange($event)"
  ></app-calendar-panel>
</div>
